import dayjs, { unix } from 'dayjs'

import { useLocalization } from '@/shared/composables/localization'

import { TIME_FORMAT, UI_DATE_FORMAT } from './constants'

export function conversionFromNumberToTime (milliseconds: number): string {
  const { t } = useLocalization()

  const durationValue = dayjs.duration(Math.floor(milliseconds / 1000), 'seconds')

  const options = {
    hours: false,
    minutes: false,
    seconds: true,
  }

  if (durationValue.hours() > 0) {
    options.hours = true
    options.minutes = true
  } else if (durationValue.minutes() > 0) {
    options.minutes = true
  }

  const format = `${options.hours ? t('mainAside.hoursFormat') : ''} ${
    options.minutes ? t('mainAside.minutesFormat') : ''
  } ${t('mainAside.secondsFormat')}`

  return durationValue.format(format)
}

export const getMonthName = (index: string, pluralization: number) => {
  const { tc } = useLocalization()
  const months: { [key: string]: string} = {
    '1': tc('common.january', pluralization),
    '2': tc('common.february', pluralization),
    '3': tc('common.march', pluralization),
    '4': tc('common.april', pluralization),
    '5': tc('common.may', pluralization),
    '6': tc('common.june', pluralization),
    '7': tc('common.july', pluralization),
    '8': tc('common.august', pluralization),
    '9': tc('common.september', pluralization),
    '10': tc('common.october', pluralization),
    '11': tc('common.november', pluralization),
    '12': tc('common.december', pluralization),
  }

  return months[index]
}

export const getDayOfWeekName = (index: string) => {
  const { t } = useLocalization()
  const days: { [key: string]: string} = {
    '0': t('common.sunday'),
    '1': t('common.monday'),
    '2': t('common.tuesday'),
    '3': t('common.wednesday'),
    '4': t('common.thursday'),
    '5': t('common.friday'),
    '6': t('common.saturday'),
  }

  return days[index]
}

export function convertTimestampToString (timestamp: number | undefined): string {
  if (!timestamp) return ''

  const dEvent = unix(timestamp).tz()
  const now = dayjs()

  const { t } = useLocalization()

  if (dEvent.isToday()) {
    return t('common.today')
  } else if (dEvent.isYesterday()) {
    return t('common.yesterday')
  } else if (dEvent.isSame(now, 'week')) {
    return dEvent.format('dddd')
  }
  return dEvent.format(`DD MMMM YYYY ${t('common.y')}`)
}

export function convertTimestampToDateTimeString (timestamp: number | undefined): string {
  if (!timestamp) return ''

  const date = unix(timestamp).tz()
  const now = dayjs().tz()

  if (date.isToday()) {
    return date.format(TIME_FORMAT)
  } else if (date.isSame(now, 'week')) {
    return date.format('dd')
  } else if (date.isSame(now, 'year')) {
    return date.format('DD.MM')
  }

  return date.format(UI_DATE_FORMAT)
}

export function formatRelativeDateTimeIn (timestamp: number | undefined): string {
  if (!timestamp) return ''

  const { t } = useLocalization()
  const date = unix(timestamp).tz()
  const time = date.format(TIME_FORMAT)

  if (date.isToday()) {
    return t('mainAside.todayIn', { time })
  }

  if (date.isYesterday()) {
    return t('mainAside.yesterdayIn', { time })
  }

  return t('mainAside.dateIn', {
    date: date.format('D MMM.'),
    time,
  })
}
